import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SiteAdminService {
  private isSiteAdmin: boolean = false;

  constructor(private router: Router) {
    this.initializeFromUrl();
    this.listenToRouteChanges();
  }

  private initializeFromUrl() {
    const siteAdmin = new URLSearchParams(window.location.search).get(
      'siteAdmin'
    );
    this.isSiteAdmin = siteAdmin === 'true';
  }

  private listenToRouteChanges() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.isSiteAdmin) {
          this.addSiteAdminToUrl();
        }
      });
  }

  private addSiteAdminToUrl() {
    const url = this.router.url.split('?')[0];
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('siteAdmin', 'true');
    this.router.navigateByUrl(`${url}?${queryParams.toString()}`, {
      replaceUrl: true,
    });
  }

  getIsSiteAdmin(): boolean {
    return this.isSiteAdmin;
  }
}
